import Accordion from '@service-victoria/component-library/components/Accordion';
import Page from '@service-victoria/component-library/components/Page';
import Tabs, { TabItem } from '@service-victoria/component-library/components/Tabs';
import TransactionActionPanel from '@service-victoria/component-library/components/TransactionActionPanel';
import { Action } from '@service-victoria/component-library/components/TransactionActionPanel/interfaces';
import React from 'react';

import bannerImg from 'app/assets/get-active-kids-voucher-banner.jpg';
import PartnerLogo from 'app/assets/get-active-victoria-logo.png';
import VicGovLogo from 'app/assets/vic-govt-logo.svg';
import { useWindowSize } from 'app/hooks';
import { constants } from 'app/utils';

import BeforeYouStart from './BeforeYouStart';
import FAQs from './FAQs';
import HowItWorks from './HowItWorks';
import * as Styled from './styled';
import { userManager } from 'app/services';

const Home: React.FC = () => {
  const windowSize = useWindowSize();
  const items: TabItem[] = [
    {
      id: 'before-you-start',
      title: 'Before you start',
      component: <BeforeYouStart />
    },
    {
      id: 'how-it-works',
      title: 'How it works',
      component: <HowItWorks />
    },
    {
      id: 'faq',
      title: 'FAQs',
      component: <FAQs />
    }
  ];

  const buttons: Action[] = [
    {
      id: 'get-started',
      label: 'Get started',
      onClick: async () => {
        await userManager.startUserSignin();
      }
    }
  ];

  return (
    <Page
      headerProps={{
        ...constants.headerProps
      }}
      title={constants.RedemptionPage.title}
      showFooter={true}
      breadCrumbs={constants.breadCrumbs}
      imgUrl={bannerImg}
      loading={false}
      opacityBetweenLoading={0}>
      <Styled.Wrapper>
        <Styled.Header>
          <Styled.Description>
            Registered Get Active Kids providers can redeem vouchers up to $200
          </Styled.Description>
          <Styled.HeaderParnershipLogo>
            <img src={PartnerLogo} alt='Get Active Victoria' />
          </Styled.HeaderParnershipLogo>
          <Styled.Line />
          <Styled.Timer>
            <Styled.Icon />
            <Styled.TextHead>
              This takes about
              <span>15 mins</span>
            </Styled.TextHead>
          </Styled.Timer>
        </Styled.Header>
        <Styled.DoubleLine />
        <Styled.Body>
          {windowSize === 'mobile' ? <Accordion items={items} /> : <Tabs items={items} />}
        </Styled.Body>
        <Styled.TransactionActionPanelWrapper>
          <TransactionActionPanel
            actions={buttons}
            programOfAgencyTitle='A program of'
            programOfAgency={{
              id: 'vic-gov',
              image: VicGovLogo,
              label: 'Victoria State Government'
            }}
            partnershipWithAgenciesTitle='In partnership with'
            partnershipWithAgencies={[
              { id: 'djpr', image: PartnerLogo, label: 'Get Active Victoria' }
            ]}
            agencyAlignment='justify'
          />
        </Styled.TransactionActionPanelWrapper>
      </Styled.Wrapper>
    </Page>
  );
};

export default Home;
